import { ReactNode } from "react";
import { ShipmentType } from "entities/shared/shipmentCard.types";
import { searchFilterStore } from "entities/SearchFilter";
import { useAppSelector } from "shared/lib/redux";
import { ValueOf } from "shared/lib/typeCheck.lib";
import { AirView } from "./MainViews/AirView";
import { ParcelView } from "./MainViews/ParcelView";
import { RailView } from "./MainViews/RailView";
import { RoadView } from "./MainViews/RoadView";
import { SeaView } from "./MainViews/SeaView";

type MainLayerProps = {
  className?: string;
};

const mainViewsMap: Record<ValueOf<typeof ShipmentType>, (props: MainLayerProps) => ReactNode> = {
  [ShipmentType.AIR]: (props) => <AirView {...props} />,
  [ShipmentType.SEA]: (props) => <SeaView {...props} />,
  [ShipmentType.RAIL]: (props) => <RailView {...props} />,
  [ShipmentType.ROAD]: (props) => <RoadView {...props} />,
  [ShipmentType.PARCEL]: (props) => <ParcelView {...props} />,
};

export const MainView: RFC<MainLayerProps> = ({ className }) => {
  const shipmentType = useAppSelector(searchFilterStore.selectors.shipment);

  return mainViewsMap[shipmentType]?.({ className });
};
